mutation teacherDisable($id: ID!) {
  teacherDisable(id: $id) {
    id
    first
    last
    email
    user {
      id
    }
    teacherPhoneNumbers {
      id
      formattedNumber
    }
  }
}
